const RECAPTCHA_SCRIPT_URL = 'https://www.google.com/recaptcha/api.js?render=';
const CLIENT_POLL_INTERVAL_MS = 100;
const CLIENT_TIMEOUT_MS = 5000;

export type RecaptchaClient = {
  ready: (callback: () => void) => void;
  execute: (siteKey: string, options: { action: string }) => Promise<string>;
};

declare global {
  interface Window {
    grecaptcha?: RecaptchaClient;
  }
}

export const loadRecaptchaScript = (siteKey: string) => {
  if (document.querySelector(`script[data-recaptcha-key="${siteKey}"]`)) return;
  const script = document.createElement('script');
  script.src = `${RECAPTCHA_SCRIPT_URL}${siteKey}`;
  script.async = true;
  script.dataset.recaptchaKey = siteKey;
  document.head.appendChild(script);
};

export const getRecaptchaClient = (
  siteKey: string,
  timeoutMs = CLIENT_TIMEOUT_MS,
): Promise<RecaptchaClient | undefined> => {
  loadRecaptchaScript(siteKey);
  if (window.grecaptcha) return Promise.resolve(window.grecaptcha);
  return new Promise((resolve) => {
    const start = Date.now();
    const interval = window.setInterval(() => {
      if (window.grecaptcha) {
        window.clearInterval(interval);
        resolve(window.grecaptcha);
      } else if (Date.now() - start >= timeoutMs) {
        window.clearInterval(interval);
        resolve(undefined);
      }
    }, CLIENT_POLL_INTERVAL_MS);
  });
};
